import cx from 'classnames';
import { icon_protector, icon_user_circle } from 'components/base/images';
import CustomSpan from 'components/common/text/CustomSpan';
import React from 'react';
import styled from 'styled-components';

import ImgCrop from 'components/common/images/ImgCrop';
import { fixedNumbering } from 'lib/library';
interface EmployeeProps {
  item: object | any;
  // page: object | any;
  // period: object | any;
  // checkedProjectProcess: object | any;
  // keyword: object | any;
}

function EmployeeCard({ item }: EmployeeProps) {
  // const [stepFilterOpen, setStepFilterOpen] = useState(false);
  // const history = useHistory();
  // const [date, setDate] = useState(null);

  // useEffect(() => {
  //   console.log('date', date);
  // }, [date]);

  return (
    <Styled.EmployeeCard data-component-name="EmployeeCard">
      <div className="employeeCard__container">
        <div className="employeeCard__content_section profile">
          <div className="employeeCard__profile_box profileImg">
            <div
              className={cx('isOnline_box', {
                active: !!item.isOnline,
              })}
            >
              <div className="isOnline"></div>
            </div>
            <div className="employeeCard__profile_image_box">
              {!!item.profileImg ? (
                <ImgCrop width={70} isCircle src={item.profileImg} alt="employee profile image" />
              ) : (
                <img className="profileImg__empty" src={icon_user_circle} alt="profile_image" />
              )}
            </div>
            <div
              className={cx('isManager', {
                active: item.authority === 1 ? true : false,
              })}
            >
              <img src={icon_protector} />
            </div>
          </div>
          <div className="employeeCard__profile_box profile">
            <div className="employeeCard__profile">
              <CustomSpan fontSize={12} fontWeight={200} fontColor="#B5B7C1">
                {/* {item.employeeNum} */}
                {fixedNumbering(item.employeeNum, 3)}
              </CustomSpan>
            </div>
            <div className="employeeCard__profile">
              <CustomSpan fontSize={16} fontWeight={500} fontColor="#33B5E4">
                {item.postPosition}
                {/* {item.authority === 0 ? 'Manager' : 'Staff'} */}
              </CustomSpan>
            </div>
            <div className="employeeCard__profile">
              <CustomSpan fontSize={16} fontWeight={500}>
                {item.name}
              </CustomSpan>
            </div>
          </div>
        </div>
        <div className="employeeCard__content_section information">
          <div className="employeeCard__information_box assigned">
            <img className="employeeCard__icon" />
            <CustomSpan fontSize={15} fontWeight={200} marginLeft={10}>
              {item.assignedTask}
            </CustomSpan>
          </div>
          <div className="employeeCard__information_box phone">
            <img className="employeeCard__icon" />
            <CustomSpan fontSize={15} fontWeight={200} marginLeft={10}>
              {item.phone}
            </CustomSpan>
          </div>
          <div className="employeeCard__information_box emain">
            <img className="employeeCard__icon" />
            <CustomSpan fontSize={15} fontWeight={200} marginLeft={10}>
              {item.email}
            </CustomSpan>
          </div>
          {/* {<div className="employeeCard__information_box project">
            <img className="employeeCard__icon" />
            <CustomSpan fontSize={15} fontWeight={500} marginLeft={10}>
              {item.participationCount}
            </CustomSpan>
            <CustomSpan fontSize={10} fontWeight={200} marginLeft={10} fontColor="#B5B7C1">
              {!!item.recentParticipantionDate &&
                moment(item.recentParticipantionDate).format('YYYY-MM-DD')}
            </CustomSpan>
          </div>} */}
        </div>
      </div>
    </Styled.EmployeeCard>
  );
}

const Styled = {
  EmployeeCard: styled.div`
    /* border: 1px solid #bababa */
    box-shadow: 0px 0px 6px rgb(0 0 0 / 16%);
    border-radius: 10px;
    width: 306px;
    height: 300px;
    padding: 20px 20px 30px;
    position: relative;
    background-color: #fff;
    &:hover {
      /* background-color: #fafafa; */
      background-color: #f4f4f4;
      cursor: pointer;
    }

    .employeeCard__container {
      width: 100%;
      padding: 0 5px;
      /* &:hover {
        &:after {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          content: '';
          z-index: 100;
          background-color: #00a6e2;
          opacity: 0.23;
          border-radius: 10px;
          box-shadow: 0px 0px 6px rgb(0 0 0 / 16%);
        }
      } */

      .employeeCard__content_section {
        &.profile {
          display: flex;
          border-bottom: 1px dashed #33b5e4;
          padding: 5px 5px 20px 5px;
        }

        &.information {
          padding: 30px 5px 0px 5px;
        }

        .employeeCard__profile_box {
          &.profileImg {
            /* width: 70px;
            height: 70px; */
            position: relative;
            margin-right: 20px;
            .employeeCard__profile_image_box {
              box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.16);
              display: block;
              border-radius: 50%;
              overflow: hidden;
              width: 70px;
              height: 70px;
            }
            .profileImg__empty {
              width: 70px;
              height: 70px;
              /* border: 1px solid #b5b7c1;
              border-radius: 50%; */
            }
            .isOnline_box {
              position: absolute;
              left: 0;
              top: 0;
              width: 20px;
              height: 20px;
              padding: 2px;
              border-radius: 10px;
              background-color: #ffffff;
              display: none;
              z-index: 10;
              &.active {
                display: block;
              }
              .isOnline {
                width: 16px;
                height: 16px;
                border-radius: 8px;
                background-color: #29dcb4;
              }
            }

            .isManager {
              position: absolute;
              bottom: 0;
              left: 0;
              width: 36px;
              height: 38px;
              display: none;
              &.active {
                display: block;
              }
            }
          }
          .employeeCard__profile {
            display: flex;
            align-items: center;

            &:nth-child(1) {
              height: 16px;
              margin-bottom: 2px;
            }
            &:nth-child(2) {
              height: 21px;
              margin-bottom: 10px;
            }
            &:nth-child(3) {
              height: 21px;
            }
          }
        }
        .employeeCard__information_box {
          display: flex;
          align-items: center;
          /* justify-content: center; */
          margin-bottom: 20px;
        }

        .employeeCard__icon {
          width: 25px;
          height: 25px;
          border-radius: 3px;
          background-color: #dfdfdf;
        }
      }
    }
  `,
};

export default React.memo(EmployeeCard);
